import { Meta } from "@/shared/components";
import { Contents } from "@/admin/features/contents";

/**
 * Страница управления контентом
 */
export function ContentsPage() {
  return (
    <>
      <Meta title="Контент" />
      <Contents />
    </>
  );
}
